module.exports = __webpack_public_path__ + "media/svg/talent_light_solo-c0f88989.svg";